import moment from 'moment-timezone';

const Helpers = {

    // Clean object
    cleanObject: function(object) {
        Object
            .entries(object)
            .forEach(([k, v]) => {
                if (v && typeof v === 'object') {
                    this.cleanObject(v);
                }
                if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined  || v === '') {
                    if (Array.isArray(object)) {
                        object.splice(k, 1);
                    }
                    else {
                        delete object[k];
                    }
                }
            });
        return object;
    },

    // Convert dates
    convertDates: function(object) {
        for (const proprety in object) {
            if (!(object[proprety] instanceof File)) {
                if (object[proprety] instanceof Date) {
                    object[proprety] = moment(object[proprety]).format('YYYY-MM-DD HH:mm:ss');
                }
                else if (object[proprety] instanceof Object) {
                    object[proprety] = Helpers.convertDates(object[proprety]);
                }
            }
        }
        return object;
    }

}

export default Helpers;
